import { RouteRecordRaw } from "vue-router";

import auth from "@/middleware/auth.middleware";

const equipoRoutes: Array<RouteRecordRaw> = [
  {
    path: "/equipos",
    name: "equipos",
    beforeEnter: [auth],
    component: () => import("@/views/crafted/pages/equipos/index.vue"),
  },
  {
    path: "equipos/:id",
    name: "equipos.ver",
    beforeEnter: [auth],
    component: () => import("@/views/crafted/pages/equipos/ver/index.vue"),
  },
];

export default equipoRoutes;
